import { auth } from '@/plugins/firebase';

// Firebase Authenticationの操作

export async function updateUserProfile(payload) {
  await getFirebaseUser()
    .updateProfile({
      displayName: payload.nickname,
      photoURL: payload.photoURL
    })
    .catch(err => console.error('Update User Profile Error', err.message));
  return;
}

export function getFirebaseUser() {
  return auth.currentUser;
}

export function getUID() {
  return getFirebaseUser().uid;
}

// ユーザー登録するときに必要な初期値をソーシャルアカウントの情報から取得する。
// ユーザーの情報が正しく取得できなかった場合はnullを返す。
export function getInitialUserValueFromSocialAccount() {
  const user = getFirebaseUser();
  if (!user) {
    return null;
  }
  return {
    email: user.email,
    nickname: user.displayName,
    photoURL: user.photoURL
  };
}
